<template lang="pug">
//-v-card(color="transparent" :dark='isDark' flat).rounded-xl
v-card(color="transparent" ligth flat).rounded-xl
  v-toolbar(dark color="#960407" dense flat).rounded-t-xl
    v-spacer
    v-toolbar-title(style="text-shadow: 0px 2px 3px rgba(0,0,0,0.6);") Ingreso al Sistema SISEP
    v-spacer
  v-card-text.pa-7.pt-4.pb-3
    v-text-field(
      light
      color="#960407"
      v-model="email"
      prepend-icon="fas fa-user"
      label="Usuario SISEP")
    div(style="margin-top:-10px;")
      v-expand-transition
        v-card(v-if="menues" style="display:block;width:100%;height:auto;overflow:hidden;border-radius:7px;" color="transparent" flat).pt-0
          div(class="box arrow-top").pa-2.text-center.pt-1.pb-0
            img(src="https://sisep.minedu.gob.bo/img/guia-usuario.png" height="57px").pa-0.ma-0
    v-text-field(
      light
      color="#960407"
      v-model="pass"
      name="user",
      label="Contraseña",
      prepend-icon="fas fa-unlock-alt",
      ref="passwordLogin",
      :append-icon="showPassword ? 'fas fa-eye' : 'fas fa-eye-slash'",
      @click:append="changeIcon",
      v-on:keyup.enter="tryLogin",
      :type="showPassword ? 'password' : 'text'")
  v-divider(color="#BBB" style="height:2px;min-height:2px;")
  v-card-actions.pa-3.pt-5.pb-5
    a.text-center(style="color:#960407;line-height:19px;font-size:15px;text-decoration:underline" @click="userInfoDialog = true").pl-1 ¿Cuál es mi usuario<br>y contraseña?
    v-spacer
    v-btn(
      :loading="isLoading",
      color="#C28D11",
      style="border-radius:10px;font-weight:bold;font-size:15px;background: linear-gradient(0deg,#b07d01 0%, #dfa92b 80%)!important;",
      @click="tryLogin" large).pl-5.pr-5 Ingresar
  v-dialog(v-model="dialogoGenerarUsuario", max-width="450px" persistent @keydown.esc="dialogoGenerarUsuario=false")
    v-card(dark style="overflow:hidden;background-image: linear-gradient(#1e415e 10%,#2b5b84 90%);").rounded-lg
      v-toolbar(dense color="#1E2933" flat)
        v-toolbar-title Generar usuario
        v-spacer
        v-btn(fab icon @click="dialogoGenerarUsuario=false")
          v-icon fas fa-times
      v-card-text.text-center.pt-3.pb-2
        div(style="max-width:340px;margin:0px auto;" v-if="!loadedUser")
          p.pb-1(style="font-size:16px;width:100%;max-width:100%;color:#D1D1D1").msg-icn.pl-2.pr-2.pb-3.mb-6 Genere su usuario <span style="color:#CFCFCF"><b>solo</b></span> si es la primera vez que accederá al sistema, o si ha solicitado<br>el restablecimiento de su contraseña.
          v-form(ref="generateform" style="width:300px").center
            v-text-field(label="Ingrese numero de carnet:" ref="ciInput" v-model="ciUser" @keyup.enter="generarUsuario" :rules="$rules.ci" v-mask="'ddddddddddddddd'" autocomplete="off")
            v-menu(ref='fechaNacMenu' v-model='fechaNacMenu' :close-on-content-click='false' transition='scale-transition' min-width='auto' offset-y)
              template(v-slot:activator='{ on, attrs }')
                v-text-field(@focus="onDateFocus" @click="onDateFocus" v-model='nacUser' label='Fecha de nacimiento' readonly v-bind='attrs' v-on='on' :rules="[$rules.nacRequired]" autocomplete="off")
              p.pa-0.pt-3.pb-3.ma-0.rounded-t-lg(style="font-size:15px;width:100%;text-align:center;background:#1E2933;color:#FFF;") Seleccione su fecha de nacimiento:
              v-date-picker(ref='picker' v-model='date' :max='new Date().toISOString().substr(0, 10)' min='1900-01-01' @input="fechaNacMenu = false" color="#375664" @update:picker-date="updatePicker" header-color="#1D2934" dark locale="es-419" no-title).rounded-b-lg.rounded-t-0.custompicker
        div(style="width:260px;margin:0px auto;" v-else).mt-4.mb-5
          span.sub-title.blue--text.text--lighten-1.font-weight-bold Usuario:&nbsp;
            span.sub-title.white--text.font-weight-regular {{ txtUser }}
          br
          span.sub-title.blue--text.text--lighten-1.font-weight-bold Contraseña:&nbsp;
            span.sub-title.white--text.font-weight-regular {{ txtPass }}
      v-divider
      v-card-actions
        v-spacer
        v-btn(color="success" large @click="generarUsuario" :loading="btnLoading" v-if="!loadedUser").pl-5.pr-5.txtn Buscar
        v-btn(color="success" large @click="cerrarDialogoGenerarUsuario" v-else).pl-5.pr-5.txtn Aceptar
        v-spacer
  v-dialog(v-model="restrictedDialog" max-width="600px")
    v-card(dark color="error")
      v-card-text.pa-10.pb-0.text-center
        v-icon(size=38 style="text-align:center;margin:0px auto !important;") fas fa-exclamation-triangle
      v-card-text.pa-10.pt-4
        p(style="text-align:center;font-size:24px;").pa-0.ma-0 Acceso Restringido Temporalmente
  v-dialog(v-model="birthdayDialog" max-width="600px" style="border-radius:10px;")
    v-card(style="border-radius:10px;")
      //-v-card-text(style="width:100%;height:70px;").pa-0
        img(src="https://sisep.minedu.gob.bo/img/advertencia.png" width="60px" style="float:left;display:inline-block").ml-5.mt-2
        h3(style="float:left;display:inline-block;color:#005E93").mt-6.ml-3 NO FUE POSIBLE IDENTIFICAR SU CUENTA
      v-card-actions.pa-0
        v-spacer
        v-btn(fab icon @click="birthdayDialog=false")
          v-icon fas fa-times
      v-card-text.text-center.pb-2(style="margin-top:-40px;")
        img(src="https://sisep.minedu.gob.bo/img/advertencia.png" style="width:100px;").pt-2.center
        h3(style="color:#005E93") NO FUE POSIBLE IDENTIFICAR SU CUENTA
      v-card-text.pb-0
        p(style="color:#444;text-align:center;").pl-2.pr-2 Se detectó que está tratando de acceder con su fecha de nacimiento como contraseña, pero al parecer éste ha sido cambiado anteriormente, si usted no ha realizado este cambio o ha olvidado su contraseña, le recomendamos escribir un mensaje de WhatsApp al Centro de Contacto para que puedan ayudarle a restablecer su cuenta y así acceda al sistema sin problemas.
      v-card-text.text-center.pa-0.pb-2
        img(src="https://sisep.minedu.gob.bo/img/numero-whatsapp.png?ver=24" style="width:220px;").pa-0
  v-dialog(v-model="userInfoDialog" max-width="500px")
    v-card(style="border-radius:10px !important;overflow:hidden;")
      v-toolbar(dense color="transparent" flat style="z-index:10000 !important;")
        v-spacer
        v-btn(fab icon @click="userInfoDialog=false")
          v-icon fas fa-times
      v-card-text.pa-0(style="margin-top:-45px;")
        v-img(src="https://sisep.minedu.gob.bo/img/user-info.png" width="100%")
  //-div.content-recaptcha(v-show="false")
    vue-recaptcha.hide-recaptcha-login(
        ref="refInvisibleRecaptcha",
        @verify="onVerifyInvisible",
        @expired="onExpiredInvisible",
        size="invisible",
        badge="inline",
        language="es",
        sitekey="6LcvWHwUAAAAABVDeanjR4WDV_m9DxWLffmj6oLQ")
</template>

<style lang="stylus">
.custompicker div div ul
  //background-color #375664 !important
  background-image linear-gradient(rgb(30, 65, 94) 10%, rgb(43, 91, 132) 90%);

.custompicker div div .active
  color #FFF !important

.custompicker .v-picker__body
  //background-color #375664 !important
  //"H.1854742.ESP@sisep.com",
  //"H.1854742@sisep.com"
  //"M.3434613.ESP@sisep.com",
  //"M.3434613@sisep.com",
  background-image linear-gradient(rgb(30, 65, 94) 10%, rgb(43, 91, 132) 90%);
</style>

<script>
export default {

  props:{
    isDark:{
      type: Boolean,
      required: false,
      default: false
    }
  },

  data: vm => ({
    enableEmail: ["yerson010203@gmail.com","wilsonprograma@gmail.com","M.5960287@sisep.com","I.4899383@sisep.com"],
    disableEmail: [
      "J.2223542.ESP@sisep.com",
      "X.4941648.ESP@sisep.com",
      "O.3961589-1O.ESP@sisep.com",
      "E.5501076.ESP@sisep.com",
      "J.2223542@sisep.com",
      "X.4941648@sisep.com",
      "O.3961589-1O@sisep.com",
      "E.5501076@sisep.com"
      ],
    expoMode: false,
    menues: false,
    restrictedDialog: false,
    userInfoDialog: false,
    email: "",
    pass: "",
    isLoading: false,
    showPassword: true,
    //captchaVerified: false,
    captchaVerified: true,
    dialogoGenerarUsuario:false,
    ciUser: "",
    date: new Date().toISOString().substr(0, 10),
    //nacUser: vm.formatDate(new Date().toISOString().substr(0, 10)),
    nacUser: null/*vm.formatDate(new Date().toISOString().substr(0, 10))*/,
//    nacUser: null,
    btnLoading: false,
    loadedUser: false,
    txtUser: "",
    txtPass: "",
    fechaNacMenu: false,
    nameDefault: 'Luis',
    birthdayDialog: false
  }),

  watch: {
    fechaNacMenu (val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
    },
    date (val) {
      this.nacUser = this.formatDate(this.date)
    },
  },

  async mounted() {
    try {
      await this.$recaptcha.init()
    }
    catch (e) {
      //console.log(e);
    }
  },

  computed: {
    computedDateFormatted () {
      return this.formatDate(this.date)
    },
  },

  methods: {
    onBlur(){
      this.menues = false;
    },
    onDateFocus(){
      this.$nextTick(() => { setTimeout(()=>{
        this.fechaNacMenu=true;
      })});
    },
    updatePicker(info){
      info = info + '-' + this.date.split('-')[2]
      this.nacUser = this.formatDate(info)
    },
    save (date) {
      this.$refs.fechaNacMenu.save(date)
    },
    formatDate (date) {
      if (!date) return null
      const [year, month, day] = date.split('-')
      return `${day} - ${month} - ${year}`
    },
    parseDate (date) {
      if (!date) return null
      const [month, day, year] = date.split('/')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },
    changeIcon() {
      this.showPassword = !this.showPassword;
      return this.$refs.passwordLogin.focus();
    },
    async tryLogin() {
      
      /*if(this.expoMode){ var enable = false; } else{ var enable = true; }
      for(var i = 0; i < this.enableEmail.length; i++){
        if(this.enableEmail[i] == this.email){
          enable = true;
        }
      }
      if(enable){
        this.isLoading = true;
        this.verifyInvisibleRecaptcha();
      }
      else{
        this.restrictedDialog = true;
      }*/

      // this disable email

      let isenb = true;
      for(var i = 0; i < this.disableEmail.length; i++){
        if(this.disableEmail[i] == this.email){
          isenb = false;
        }
      }
      if(isenb){
        this.isLoading = true;
        this.verifyInvisibleRecaptcha();
      }
      else{
        this.$snotify.error("El usuario no puedo ser identificado.");
      }
    },
    onVerifyInvisible: function() {
      this.captchaVerified = true;
    },
    onExpiredInvisible: function() {
      this.captchaVerified = false;
    },
    verifyInvisibleRecaptcha: function() {
      /*if (!this.captchaVerified) {
        //console.log("vc");
        this.$refs.refInvisibleRecaptcha.execute();
        var count = 0;
					var intervalInvisibleCaptcha = setInterval(function(){
						count++;
						if(count>=15){
							clearInterval(intervalInvisibleCaptcha);
							this.$snotify.error("No se puede conectar con el servidor de recaptcha.\nverifique su conexión a internet.");
							this.isLoading = false;
						}
						if(this.captchaVerified){
							clearInterval(intervalInvisibleCaptcha);
              this.isLoading = false;
							this.loginAction();
						}
					}.bind(this),1000);
      }
      else{
        this.loginAction();
      }*/
      this.loginAction();
    },
    async loginAction(){
      this.isLoading = true;
      try {
        this.isLoading = true;
        let response = await axios.post(
          'https://sisep.minedu.gob.bo/app/app-login/api/v1/oauth/token',
          //TODO2023'/app/app-login/api/v1/oauth/token',
          {user:this.email,pass:this.pass},
          {headers:{'Content-Type':'application/json','Accept':'application/json'}}
        );
        /* SET TOKEN CREDENTIALS ON STORAGE */
        this.$store.state.token = response.data.token.access_token;
        localStorage.setItem("auth", response.data.token.access_token);
        this.$store.state.user.username = response.data.user.user_name;
        this.$store.state.user.email = response.data.user.email;
        //2021this.loginWithToken();

        //this.isLoading = true;
        this.isLoading = false;
        this.$router.push("/");
          /*setTimeout(()=>{
            this.isLoading = false;
            this.$router.push("/");
          }, 5000);*/

        /* SET TOKEN CREDENTIALS ON STORAGE */
      } catch (error) {
        if(error.response){
          if(error.response.status == 401){
            this.verifyDefaultPassword();
          }
          else if(error.response.status == 406){
            this.$snotify.error("Verifique sus datos e intente nuevamente.");
          }
          else{this.$snotify.error("Servidor desconectado o en mantenimiento.");}
        }
        else{this.$snotify.error(error.message);}
      } finally {
        this.isLoading = false;
      }
    },
    async verifyDefaultPassword(){
      this.isLoading = true;
      try{
        //this.$snotify.error("Usuario no identificado, revise su usuario o contraseña.");
        let response = await axios.post(
          'https://sisep.minedu.gob.bo/db-service/db-service-oauth-acl/api/v1/birthdayStatus',
          //TODO2023'/db-service/db-service-oauth-acl/api/v1/birthdayStatus',
          {user:this.email,pass:this.pass},
          {headers:{'Content-Type':'application/json','Accept':'application/json'}}
        );
        if(response.data.status == 'isdefault'){
          this.nameDefault = response.data.nombre;
          this.birthdayDialog = true;
          //this.$snotify.success("Intent with default birthday.");
        }
        else{
          this.$snotify.error("Usuario no identificado, revise su usuario o contraseña.");
        }
      } catch (error) {
        this.$snotify.error("Usuario no identificado, revise su usuario o contraseña.");
      } finally {
        this.isLoading = false;
      }
    },
    async loginWithToken(){
      try {
        this.isLoading = false;
        let response = await axios.post(
          // FIX:
          '/app/app-rda/oauth/token',
          //'http://sisep.minedu.gob.bo:8081/app/app-rda/oauth/token',
          {
            client_id: 1,
            client_secret: 'ZSisTCEmtpgrBXN9HKsULx68XC0okGBNZj3wbcPC',
            grant_type: 'password',
            username: this.email,
            password: this.pass
          },
          {headers:{'Content-Type':'application/json','Accept':'application/json'}}
        );
        /* SET TOKEN CREDENTIALS ON STORAGE */
        localStorage.setItem("auth_rda", response.data.access_token);
        this.$router.push("/");
        /* SET TOKEN CREDENTIALS ON STORAGE */
      } catch (error) {
        this.$snotify.error("Error de autenticacion en rda");
      } finally {
        this.isLoading = false;
      }
    },
    abrirDialogoGenerarUsuario() {
      this.dialogoGenerarUsuario = true;
      this.email = "";
      this.pass = "";
      this.loadedUser = false;
      this.ciUser = "";
      this.nacUser = null;
      this.nacUser = null;/*this.formatDate(new Date().toISOString().substr(0, 10))*/
      this.$nextTick(() => { setTimeout(()=>{
        this.$refs.generateform.resetValidation();
        this.$refs.ciInput.focus();
      })});
    },
    async generarUsuario() {
      if(this.$refs.generateform.validate()){
        try {
          this.btnLoading = true;
          // FIX:
          let resultado = await axios.get("https://sisep.minedu.gob.bo/app/app-abms/api/v1/servicio_app_abms/usuario/vistaObtenerUsuarioPorCi/" + this.ciUser + "/" + this.nacUser.replace(/\s/g,''));
          //TODO2023let resultado = await axios.get("/app/app-abms/api/v1/servicio_app_abms/usuario/vistaObtenerUsuarioPorCi/" + this.ciUser + "/" + this.nacUser.replace(/\s/g,''));
          //let resultado = await axios.get("http://sisep.minedu.gob.bo:8081/app/app-abms/api/v1/servicio_app_abms/usuario/vistaObtenerUsuarioPorCi/" + this.ciUser + "/" + this.nacUser.replace(/\s/g,''));
          if ((resultado.data.status = 201 && resultado.data.email !== null)) {
            this.loadedUser = true;
            this.txtUser = resultado.data.email
            this.txtPass = resultado.data.fechaNacimiento
            /* Resetear usuario */
            // let res = await axios.get("http://sisep.minedu.gob.bo:8083/ascenso/sisep/"+this.ciUser);
            // console.log("RSTSISEP:"+res.data.status);
            /* Resetear usuario */
          }
          else{
            this.$snotify.error("No se encontro ningun registro con el criterio proporcionado.");
            this.$nextTick(() => { setTimeout(()=>{
              this.$refs.ciInput.focus();
            })});
          }
          this.btnLoading = false;
        } catch (error) {
          this.btnLoading = false;
          this.$snotify.error("No se obtuvo ninguna respuesta.");
        }
      }
      else{
        this.$snotify.error("Revise los campos antes de generar un usuario.");
      }
    },
    cerrarDialogoGenerarUsuario(){
      this.email = this.txtUser;
      this.pass = this.txtPass;
      this.dialogoGenerarUsuario = false;
    }
  }
};
</script>
